const regexes = {
  notWord: /\W/g,
};

const isStringValueTrue = (x) =>
  x?.trim().replace(regexes.notWord, '') === 'true';

export const isIngestionFormatTypeEnabled = isStringValueTrue(
  process.env.REACT_APP_ENABLE_INGESTION_FORMAT_TYPE
);

const diagnostic =
  (process.env.REACT_APP_DIVESTITURE_DIAGNOSTIC || '').replace(/\W/g, '') !==
  'false';

const diagnosticDebuggingControls = !!(
  process.env.REACT_APP_ENVIRONMENT_NAMESPACE.match(/dev$/) ||
  process.env.REACT_APP_ENVIRONMENT_NAMESPACE.match(/qa$/) ||
  process.env.REACT_APP_ENVIRONMENT_NAMESPACE.match(/test$/) ||
  process.env.REACT_APP_ENVIRONMENT_NAMESPACE.match(/uat$/)
);

const analysisGroupsPageEnabled =
  (process.env.REACT_APP_ANALYSIS_GROUPS_PAGE_ENABLED || '').replace(
    /\W/g,
    ''
  ) !== 'false';

const tpalEnabled =
  (process.env.REACT_APP_TPAL_ENABLED || '').replace(/\W/g, '') !== 'false';

const selectionCommentsEnabled =
  (process.env.REACT_APP_SELECTION_COMMENTS_ENABLED || '').replace(
    /\W/g,
    ''
  ) === 'true';

const hideAnalysisGrid =
  (process.env.REACT_APP_HIDE_ANALYSIS_GRID || '').replace(/\W/g, '') ===
  'true';

const appInsightsInstrumentationKey =
  process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY;

const downloadExcelTableEnabled =
  (process.env.REACT_APP_ENABLE_EXCEL_TABLE_DOWNLOAD || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isTableauEnabled =
  (process.env.REACT_APP_ENABLE_TABLEAU || '').trim().replace(/\W/g, '') ===
  'true';

const isWorksheetIngestionEnabled =
  (process.env.REACT_APP_ENABLE_WORKSHEET_INGESTION || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isContentHubEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_ENABLE_CONTENT_HUB || '').trim().replace(/\W/g, '') ===
  'true';

const isGLTEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_GLT_ENABLED || '').trim().replace(/\W/g, '') ===
  'true';

const isUserManagementEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_USER_MANAGEMENT_ENABLED || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isUserInAADEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_USER_IN_AAD_ENABLED || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isProjectInitiationFromCDEEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_PROJECT_INITIATION_CDE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

export const isProjectListingEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_ENABLE_PROJECT_LISTING || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isP3Enabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_CS_P3_ENABLED || '').replace(/\W/g, '') === 'true';

export const isInlineCommentingEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_FEATURE_FLAG_INLINE_COMMENTING || '').replace(
    /\W/g,
    ''
  ) === 'true';

export const inlineCommentingEnabledForStructuredAnalysisMfe =
  // eslint-disable-next-line no-undef
  (
    process.env
      .REACT_APP_FEATURE_FLAG_INLINE_COMMENTING_FOR_STRUCTURED_ANALYSIS_MFE ||
    ''
  ).replace(/\W/g, '') === 'true';

export const isP3BPlusEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_CS_P3BPLUS_ENABLED || '').replace(/\W/g, '') ===
  'true';

export const isReportLivePreview =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_REPORT_LIVE_PREVIEW || '').replace(/\W/g, '') ===
  'true';

export const isReportBuilderLivePreviewEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_CS_LIVEPREVIEW_ENABLED || '').replace(/\W/g, '') ===
  'true';

export const isCreateFreeFormAnalysisApiEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_CREATE_FFA_API_ENABLE || '').replace(/\W/g, '') !==
  'false';

export const isDisplayFormatEnabled =
  (process.env.REACT_APP_DISPLAY_FORMAT_TYPE || '').replace(/\W/g, '') ===
  'true';

export const isSVGminitableIngestionEnabled =
  (process.env.REACT_APP_DISPLAY_SVG_INGESTION_MINITABLE || '').replace(
    /\W/g,
    ''
  ) === 'true';

const isProjectImportEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_ENABLE_PROJECT_IMPORT || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isAutoSaveEnabled =
  (process.env.REACT_APP_AUTO_SAVE_ENABLED || '').replace(/\W/g, '') !==
  'false';

const isAutoSaveDevMode =
  (process.env.REACT_APP_AUTO_SAVE_ISDEV || '').trim().replace(/\W/g, '') ===
  'true';

const isEnabledFileFoldersFeature =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_ENABLE_FILE_FOLDERS_FEATURE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isLiveLinkingEnabled =
  (process.env.REACT_APP_LIVE_LINK_FEATURE_ENABLED || 'false')
    .replace(/\W/g, '')
    .toLowerCase() === 'true';

const isStructuredAnalysesTitleEditable =
  (process.env.REACT_APP_EDIT_STRUCTURED_ANALYSES_TITLE_ENABLED || 'false')
    .trim()
    .replace(/\W/g, '') === 'true';

const isDisabledCountApi =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_DISABLE_COUNT_API || '').trim().replace(/\W/g, '') ===
  'true';

const isVersioningPhase1Enabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_VERSIONING_PHASE1_ENABLE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

export const isLiveReportPreviewEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_LIVE_REPORT_PREVIEW_MFE_ENABLE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isPOTopicRefactorEnabled =
  (process.env.REACT_APP_PROJECT_TOPIC_MFE_ENABLED || 'false')
    .trim()
    .replace(/\W/g, '') === 'true';

const isPowerBiIngestionEnabled =
  (process.env.REACT_APP_ENABLE_POWERBI_INGESTION || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isImageUploadEnabled =
  (process.env.REACT_APP_IS_IMAGE_UPLOAD_ENABLED || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isGlobalToggleEnabled =
  (process.env.REACT_APP_ENABLE_GLOBAL_TOGGLE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isContentTemplateSetEnabled =
  (process.env.REACT_APP_CONTENT_TEMPLATE_SET_ENABLED || '')
    .trim()
    .replace(/\W/g, '') === 'true';

export const isCKEditorHighlightEnabled =
  (process.env.REACT_APP_FEATURE_FLAG_CKEDITOR_HIGHLIGHT || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isContentHubEnabledForClients =
  (process.env.REACT_APP_IS_CONTENT_HUB_ENABLED_FOR_CLIENTS || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isUserAccessTokenV2Enabled =
  (process.env.REACT_APP_FEATURE_FLAG_AUTH_TOKEN_V2 || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isLegalStatementInCombineListEnabled =
  (process.env.REACT_APP_LEGAL_STATEMENT_IN_COMBINE_TERRITORY_LIST || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isStructuredAnalysisLivePreviewEnabled =
  (process.env.REACT_APP_STRUCTURED_ANALYSIS_LRP_ENABLE || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isLocalizationBtnEnabled =
  (process.env.REACT_APP_LOCALIZATION_BUTTON_ENABLED || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isSVGScalingEnabled = isStringValueTrue(
  process.env.REACT_APP_DISPLAY_SVG_SCALING
);

const isLanguageSelectionEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_JAPAN_LOCALIZATION_LANGUAGE_SELECT || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const isLRPLoaderFlagEnabled =
  // eslint-disable-next-line no-undef
  (process.env.REACT_APP_ENABLE_LRP_LOADER_FLAG || '')
    .trim()
    .replace(/\W/g, '') === 'true';

const supportEmailNew = process.env.REACT_APP_SUPPORT_EMAIL_NEW;

export default {
  diagnostic,
  diagnosticDebuggingControls,
  downloadExcelTableEnabled,
  isTableauEnabled,
  isWorksheetIngestionEnabled,
  tpalEnabled,
  selectionCommentsEnabled,
  analysisGroupsPageEnabled,
  hideAnalysisGrid,
  appInsightsInstrumentationKey,
  isContentHubEnabled,
  isReportLivePreview,
  isDisplayFormatEnabled,
  isProjectImportEnabled,
  isAutoSaveEnabled,
  isAutoSaveDevMode,
  isEnabledFileFoldersFeature,
  isLiveLinkingEnabled,
  isDisabledCountApi,
  isStructuredAnalysesTitleEditable,
  isVersioningPhase1Enabled,
  isPOTopicRefactorEnabled,
  isP3Enabled,
  isInlineCommentingEnabled,
  isPowerBiIngestionEnabled,
  isImageUploadEnabled,
  isProjectListingEnabled,
  isGlobalToggleEnabled,
  isContentTemplateSetEnabled,
  isCKEditorHighlightEnabled,
  isContentHubEnabledForClients,
  isUserAccessTokenV2Enabled,
  isGLTEnabled,
  isUserManagementEnabled,
  isLegalStatementInCombineListEnabled,
  isStructuredAnalysisLivePreviewEnabled,
  isProjectInitiationFromCDEEnabled,
  isUserInAADEnabled,
  isLocalizationBtnEnabled,
  isSVGScalingEnabled,
  isLanguageSelectionEnabled,
  isLRPLoaderFlagEnabled,
  supportEmailNew,
};
